import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/pt-br';
import { Tooltip, Stack, Box, Typography } from '@mui/material';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.locale('pt-br');

export function LastSyncCell({ lastSyncAt }) {
    if (!lastSyncAt) {
        return (
            <Typography variant="body2" color="textSecondary" fontStyle="italic">
                Nunca sincronizado
            </Typography>
        );
    }

    const sync = dayjs(lastSyncAt, 'DD-MM-YYYY HH:mm:ss');

    if (!sync.isValid()) {
        return <Typography variant="body2">{lastSyncAt}</Typography>;
    }

    const minutesAgo = dayjs().diff(sync, 'minute');

    let color;
    if (minutesAgo <= 15) {
        color = '#2e7d32';
    } else if (minutesAgo <= 60) {
        color = '#ed6c02';
    } else {
        color = '#d32f2f';
    }

    return (
        <Tooltip title={sync.format('DD/MM/YYYY HH:mm:ss')} arrow placement="top">
            <Stack direction="row" spacing={1} alignItems="center" sx={{ cursor: 'default' }}>
                <Box
                    sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: color,
                        flexShrink: 0,
                    }}
                />
                <Typography variant="body2">
                    {sync.fromNow()}
                </Typography>
            </Stack>
        </Tooltip>
    );
}